import { createFileRoute } from '@tanstack/react-router'
import { WorkflowEditorPage } from '@/features/workflows/ui/workflow-editor-page'

export const Route = createFileRoute('/_authenticated/tasks/workflows/$workflowId/edit')({
	component: () => {
		const { workflowId } = Route.useParams()
		return <WorkflowEditorPage workflowId={workflowId} />
	},
})
